// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cfelpyucqllkshmlkwxz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNmZWxweXVjcWxsa3NobWxrd3h6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ0Mjk3OTUsImV4cCI6MjA1MDAwNTc5NX0.aTvZHe-5wZzFN7WVGz5AxHnNPnTLEOYhpXcR6gqStBk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});